import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import { CmsEntities } from 'client/data/models/cms';
import { CategoryCards } from 'site-modules/shared/components/category-cards/category-cards';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';

const CONTENT_GRID_SECTION_HEADING_CLASSNAME = {
  textClassName: 'heading-1 fw-bold',
  containerClassName: 'text-capitalize text-md-center mb-0 text-cool-gray-10 mb-1',
};

export function HomeContentGrid({ content, isMobile = false }) {
  if (!(content && content.children().length)) {
    return null;
  }

  const sponsoredContents = content
    .children()
    .filter(c => c.metadata('sponsored-title').value() || c.metadata('promoLabel').value());

  return (
    <Container className="home-content-grid px-2 px-sm-0_5 px-lg-0" data-tracking-parent="edm-entry-home-content-grid">
      <CategoryCards
        entry={content}
        sectionHeadingClassName={CONTENT_GRID_SECTION_HEADING_CLASSNAME}
        hideMobilePromoText={false}
        enableClickTracking
        headerTag="h2"
        cardHeaderTag="h3"
        isMobile={isMobile}
        noFollowLinks
      />
      {sponsoredContents.map((item, index) => (
        <Fragment key={item.id}>
          {!isMobile && (
            <AdUnit adName="featuredarticle" md lg xl position={`${index + 1}`} oneByOne renderWhenViewable={false} />
          )}
          <AdUnit adName="mfeaturedarticle" xs sm position={`${index + 1}`} oneByOne renderWhenViewable={false} />
        </Fragment>
      ))}
    </Container>
  );
}

HomeContentGrid.propTypes = {
  content: CmsEntities.Content.isRequired,
  isMobile: PropTypes.bool,
};
